import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-geburtsdatum',
    templateUrl: './calendar-field.component.html'
} )
export class BirthDateFormComponent extends AbstractFieldComponent<Date> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.birthDate' );
    }

    set value( t: Date | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.birthDate = t;
        }
    }

    get value(): Date | undefined {
        return this.jobapplication?.birthDate;
    }
}
